import { __awaiter, __extends, __generator, __spreadArrays } from "tslib";
import { PauseIcon } from './icons/pause-icon';
import { PlayIcon } from './icons/play-icon';
import { namespacedClassnames } from '../../common/namespace-classes';
import * as React from 'react';
import { PlayerLoader } from './icons/player-loader';
import { Text } from '../../new-libby';
import { Tooltip } from '../../primitives';
import { compKey } from './key';
export var getAudioFulltime = function (audioLength, annotations) {
    if (annotations === void 0) { annotations = []; }
    return audioLength ? annotations
        .reduce(function (acc, curr) { return acc + curr.length; }, audioLength) : 0;
};
export var getAnnotationOffsets = function (annotations) {
    return annotations.reduce(function (acc, curr) {
        return __spreadArrays(acc, [acc[acc.length - 1] + curr.length]);
    }, [0]);
};
export var getRelativeCurrentTime = function (currentTime, annotations) {
    if (annotations) {
        var newCurrentTime = annotations.reduce(function (acc, curr) {
            return acc + (currentTime > curr.startOffset && (currentTime < (curr.startOffset + curr.length))
                ? (curr.startOffset - acc)
                : 0);
        }, currentTime);
        return newCurrentTime;
    }
    return currentTime;
};
export var getProgressBarCurrentTime2 = function (audioCurrentTime, annotations) {
    if (annotations) {
        return annotations.reduce(function (acc, curr) {
            return acc + (audioCurrentTime > curr.startOffset
                ? curr.length
                : 0);
        }, audioCurrentTime);
    }
    return audioCurrentTime;
};
export var formatPlaybackTime = function (time) {
    var minutes = Math.floor(time / 60);
    var seconds = Math.floor(time % 60);
    return minutes + ":" + (seconds < 10 ? '0' : '') + seconds;
};
var SimpleAudioPlayer = /** @class */ (function (_super) {
    __extends(SimpleAudioPlayer, _super);
    function SimpleAudioPlayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.audio = null;
        _this.audioProgressContainer = null;
        _this.seekInProgress = false;
        _this.audioFulltime = 0;
        _this.state = {
            paused: true,
            disabled: true,
            currentTime: 0,
            hoverBarPercentage: 0
        };
        _this.isPlaying = false;
        _this.isAudioPlayerDebugEnabled = function () {
            return localStorage.getItem('__ansAudioPlayerDebug') === 'true';
        };
        _this.logError = function () {
            if (_this.isAudioPlayerDebugEnabled()) {
                console.log('Audio Player Error: ', _this.audio ? _this.audio.error : 'No audio element!'); // tslint:disable-line
            }
        };
        _this.logStalled = function () {
            if (_this.isAudioPlayerDebugEnabled()) {
                console.log('stalled'); // tslint:disable-line
            }
        };
        _this.maybePlayAnnotationAction = function (audioFileAnnotations, onAnnotationPlayed) {
            var withOffsets = getAnnotationOffsets(audioFileAnnotations);
            var unvisitedHitLocations = audioFileAnnotations.filter(function (audioFileAnnotation, idx) {
                var _a;
                var wasVisited = _this.state.hitAnnotation === audioFileAnnotation.startOffset;
                var isHit = (audioFileAnnotation.startOffset - withOffsets[idx]) === Math.floor(((_a = _this.audio) === null || _a === void 0 ? void 0 : _a.currentTime) || 0);
                return !wasVisited && isHit;
            });
            unvisitedHitLocations.forEach(function (unvisitedHitLocation) {
                _this.setState({ hitAnnotation: unvisitedHitLocation.startOffset });
                onAnnotationPlayed(unvisitedHitLocation).forEach(function (element) { return __awaiter(_this, void 0, void 0, function () {
                    var audio;
                    return __generator(this, function (_a) {
                        if (element.type === 'play-sound') {
                            this.togglePause();
                            audio = new Audio(element.audioFileUrl);
                            audio.play();
                            audio.addEventListener('ended', this.togglePause);
                        }
                        return [2 /*return*/];
                    });
                }); });
            });
        };
        _this.updateCurrentTime = function () {
            var _a;
            if (!_this.seekInProgress && _this.audio) {
                if (_this.props.audioFileAnnotations !== undefined && _this.props.onAnnotationPlayed) {
                    _this.maybePlayAnnotationAction(_this.props.audioFileAnnotations, _this.props.onAnnotationPlayed);
                }
                _this.setState({ currentTime: _this.getProgressBarCurrentTime(((_a = _this.audio) === null || _a === void 0 ? void 0 : _a.currentTime) || 0) });
            }
        };
        _this.enablePlay = function () {
            _this.audioFulltime = _this.getAudioFullTime();
            var disabled = !!_this.props.disabled;
            _this.setState({ disabled: disabled });
            if (_this.props.updateDisabled) {
                _this.props.updateDisabled(false);
            }
        };
        _this.safelyPauseAudio = function () {
            if (_this.audio) {
                _this.audio.pause();
            }
        };
        _this.togglePause = function () {
            var _a = _this.props, onPlay = _a.onPlay, onPause = _a.onPause;
            var _b = _this.state, disabled = _b.disabled, paused = _b.paused;
            if (!disabled && _this.audio && !_this.isPlaying) {
                var shouldPause_1 = !paused;
                try {
                    if (shouldPause_1) {
                        _this.setState({ paused: shouldPause_1 }, function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                this.safelyPauseAudio();
                                if (onPause) {
                                    onPause();
                                }
                                return [2 /*return*/];
                            });
                        }); });
                    }
                    else {
                        _this.isPlaying = true;
                        _this.setState({ disabled: true }, function () { return __awaiter(_this, void 0, void 0, function () {
                            var error_1;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!this.audio) return [3 /*break*/, 5];
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([1, 3, 4, 5]);
                                        return [4 /*yield*/, this.audio.play()];
                                    case 2:
                                        _a.sent();
                                        return [3 /*break*/, 5];
                                    case 3:
                                        error_1 = _a.sent();
                                        console.info(error_1);
                                        return [3 /*break*/, 5];
                                    case 4:
                                        this.isPlaying = false;
                                        this.setState({ disabled: false, paused: shouldPause_1 });
                                        return [7 /*endfinally*/];
                                    case 5: return [2 /*return*/];
                                }
                            });
                        }); });
                        if (onPlay) {
                            onPlay();
                        }
                    }
                }
                catch (error) {
                    // tslint:disable-next-line
                    console.info(error);
                }
            }
        };
        _this.adjustDisplayedTime = function (event) {
            var disabled = _this.state.disabled;
            var isStartSeekEvent = event.type === 'mousedown' || event.type === 'touchstart';
            if (!disabled && isStartSeekEvent) {
                _this.seekInProgress = true;
            }
            else if (!_this.seekInProgress) {
                return;
            }
            event.preventDefault();
            if (_this.audioProgressContainer && _this.audio) {
                var boundingRect = _this.audioProgressContainer.getBoundingClientRect();
                var isTouch = event.type === 'touchmove' || event.type === 'touchstart';
                var pageX = isTouch ? event.targetTouches.item(0).pageX : event.pageX;
                var position = (pageX - boundingRect.left - document.body.scrollLeft) || 1;
                var containerWidth = boundingRect.width || 1;
                var progressPercentage = Math.max(0, Math.min(1, position / containerWidth));
                _this.setState({
                    currentTime: progressPercentage * _this.audioFulltime,
                    hoverBarPercentage: 0,
                    hitAnnotation: undefined
                });
            }
        };
        _this.getRelativeCurrentTime = function (currentTime) {
            return getRelativeCurrentTime(currentTime, _this.props.audioFileAnnotations);
        };
        _this.getProgressBarCurrentTime = function (audioCurrentTime) {
            if (_this.props.audioFileAnnotations) {
                var withOffsets_1 = getAnnotationOffsets(_this.props.audioFileAnnotations);
                var newCurrentTime = _this.props.audioFileAnnotations.reduce(function (acc, curr, idx) {
                    var audioWithOffset = (audioCurrentTime + withOffsets_1[idx]);
                    return acc + (audioWithOffset > curr.startOffset
                        ? audioWithOffset - acc + curr.length
                        : 0);
                }, audioCurrentTime);
                return newCurrentTime;
            }
            return audioCurrentTime;
        };
        // Get real audio file currentTime
        _this.getNormalizedCurrentTime = function () {
            var audioFileAnnotations = _this.props.audioFileAnnotations;
            if (audioFileAnnotations) {
                var relativeCurrentTime_1 = getRelativeCurrentTime(_this.state.currentTime, audioFileAnnotations);
                return audioFileAnnotations.reduce(function (acc, curr) {
                    return acc - (relativeCurrentTime_1 > curr.startOffset ? curr.length : 0);
                }, relativeCurrentTime_1);
            }
            return _this.state.currentTime;
        };
        _this.seek = function (event) {
            if (!_this.seekInProgress || !_this.audio) {
                return;
            }
            event.preventDefault();
            _this.seekInProgress = false;
            _this.audio.currentTime = _this.getNormalizedCurrentTime();
        };
        _this.setProgressContainerRef = function (ref) {
            if (ref) {
                _this.audioProgressContainer = ref;
            }
        };
        _this.onProgressBarMouseMove = function (event) {
            if (_this.audioProgressContainer && _this.audio) {
                var boundingRect = _this.audioProgressContainer.getBoundingClientRect();
                var position = event.pageX - boundingRect.left - document.body.scrollLeft;
                var containerWidth = boundingRect.width;
                var progressPercentage = (_this.state.currentTime / _this.audioFulltime);
                var hoverBarPercentage = 100 * Math.max(0, Math.min(1, (position / containerWidth) - progressPercentage));
                _this.setState({ hoverBarPercentage: hoverBarPercentage });
            }
        };
        _this.jumpToAnnotation = function (event, audioFileAnnotation) {
            var disabled = _this.state.disabled;
            var isStartSeekEvent = event.type === 'mousedown' || event.type === 'touchstart';
            if (!disabled && isStartSeekEvent) {
                _this.seekInProgress = true;
            }
            else if (!_this.seekInProgress) {
                return;
            }
            event.preventDefault();
            if (_this.audioProgressContainer && _this.audio) {
                event.stopPropagation();
                var boundingRect = _this.audioProgressContainer.getBoundingClientRect();
                var position = (boundingRect.left - document.body.scrollLeft) || 1;
                var containerWidth = boundingRect.width || 1;
                var progressPercentage = Math.max(0, Math.min(1, position / containerWidth));
                _this.setState({
                    currentTime: progressPercentage * audioFileAnnotation.startOffset,
                    hoverBarPercentage: 0,
                    hitAnnotation: undefined
                });
            }
        };
        _this.renderAnnotation = function (audioFileAnnotations, renderAnnotationTooltip) {
            return audioFileAnnotations.map(function (audioFileAnnotation) {
                var annotationLocation = 100 * audioFileAnnotation.startOffset / (_this.audioFulltime || 1) + "%";
                var annotationClicked = function (e) { return _this.jumpToAnnotation(e, audioFileAnnotation); };
                var normalizedAnnotationLength = 100 * audioFileAnnotation.length / (_this.audioFulltime || 1) + "%";
                var annotation = React.createElement("div", { onMouseDown: annotationClicked, className: 'annotation-wrapper' });
                var tooltipBody = renderAnnotationTooltip === null || renderAnnotationTooltip === void 0 ? void 0 : renderAnnotationTooltip(audioFileAnnotation);
                var tooltipElem = tooltipBody ? (React.createElement(Tooltip, { relativeToBody: true, body: tooltipBody }, annotation)) : annotation;
                return (React.createElement("div", { key: audioFileAnnotation.startOffset, className: 'annotation-start', style: { left: annotationLocation, width: normalizedAnnotationLength } }, tooltipElem));
            });
        };
        _this.onProgressBarMouseOut = function () {
            _this.setState({ hoverBarPercentage: 0 });
        };
        _this.getAudioFullTime = function () {
            var audioDuration = _this.audio && _this.audio.duration || 0;
            return getAudioFulltime(audioDuration, _this.props.audioFileAnnotations);
        };
        return _this;
    }
    SimpleAudioPlayer.prototype.componentDidMount = function () {
        window.addEventListener('mouseup', this.seek);
        document.addEventListener('touchend', this.seek);
        window.addEventListener('mousemove', this.adjustDisplayedTime);
        document.addEventListener('touchmove', this.adjustDisplayedTime);
        var audio = this.audio = document.createElement('audio');
        audio.playbackRate = this.props.playbackRate || 1;
        audio.addEventListener('timeupdate', this.updateCurrentTime);
        audio.addEventListener('loadedmetadata', this.updateCurrentTime);
        audio.addEventListener('ended', this.togglePause);
        audio.addEventListener('canplay', this.enablePlay);
        audio.addEventListener('error', this.logError);
        audio.addEventListener('stalled', this.logStalled);
        audio.src = this.props.audioUrl;
        audio.preload = 'auto';
    };
    SimpleAudioPlayer.prototype.componentWillUnmount = function () {
        window.removeEventListener('mousemove', this.adjustDisplayedTime);
        document.removeEventListener('touchmove', this.adjustDisplayedTime);
        window.removeEventListener('mouseup', this.seek);
        document.removeEventListener('touchend', this.seek);
        if (this.audio) {
            this.audio.removeEventListener('timeupdate', this.updateCurrentTime);
            this.audio.removeEventListener('loadedmetadata', this.updateCurrentTime);
            this.audio.removeEventListener('canplaythrough', this.enablePlay);
            this.audio.removeEventListener('error', this.logError);
            this.audio.removeEventListener('stalled', this.logStalled);
            this.audio.pause();
        }
    };
    SimpleAudioPlayer.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.audio) {
            if (this.props.playbackRate !== nextProps.playbackRate) {
                this.audio.playbackRate = nextProps.playbackRate || 1;
            }
            if (this.props.audioUrl !== nextProps.audioUrl) {
                this.audio.src = nextProps.audioUrl;
            }
            this.audioFulltime = this.getAudioFullTime();
        }
    };
    SimpleAudioPlayer.prototype.render = function () {
        var classNames = namespacedClassnames(compKey, { 'with-title': this.props.title, disabled: this.state.disabled });
        var currentTime = this.getRelativeCurrentTime(this.state.currentTime);
        var progressBarWidth = 100 * currentTime / (this.audioFulltime || 1) + "%";
        var maybeTitle = this.props.title ? (React.createElement(Text, { type: 'hxsm', className: 'title', ellipsis: true }, this.props.title)) : null;
        var playerLoaderTooltipText = 'The call is loading, this might take a few moments.';
        var showPlayerLoader = this.state.disabled && !this.props.disabled;
        var showPlayerTooltip = showPlayerLoader || this.props.disabled;
        var tooltipText = showPlayerLoader ? playerLoaderTooltipText : this.props.disabled;
        var tooltipBody = React.createElement("div", { className: 'audio-player-tooltip-body' }, tooltipText);
        var playIcon = (React.createElement("div", { className: 'play-icon', onClick: this.togglePause },
            this.state.paused ? React.createElement(PlayIcon, null) : React.createElement(PauseIcon, null),
            showPlayerLoader && React.createElement(PlayerLoader, null)));
        var renderFileAnnotation = (!!this.props.audioFileAnnotations
            ? this.renderAnnotation(this.props.audioFileAnnotations, this.props.renderAnnotationTooltip)
            : null);
        return (React.createElement("div", { className: classNames },
            showPlayerTooltip ? React.createElement(Tooltip, { body: tooltipBody }, playIcon) : playIcon,
            React.createElement("div", { className: 'main-wrapper' },
                maybeTitle,
                React.createElement("div", { className: 'progress-bar-wrapper' },
                    React.createElement("div", { className: 'progress-bar', ref: this.setProgressContainerRef, onMouseDown: this.adjustDisplayedTime, onTouchStart: this.adjustDisplayedTime, onMouseMove: this.onProgressBarMouseMove, onMouseOut: this.onProgressBarMouseOut },
                        React.createElement("div", { className: 'progress-bar-track' },
                            React.createElement("div", { className: 'progress-bar-inner', style: { width: progressBarWidth } }),
                            React.createElement("div", { className: 'hover-bar', style: { width: this.state.hoverBarPercentage + "%" } })),
                        React.createElement("div", { className: 'annotations-container' }, renderFileAnnotation)),
                    React.createElement("span", { className: 'time' }, formatPlaybackTime(currentTime) + "/" + formatPlaybackTime(this.audioFulltime))))));
    };
    return SimpleAudioPlayer;
}(React.PureComponent));
export { SimpleAudioPlayer };
//# sourceMappingURL=index.js.map